export type ColumnId =
  | 'Checkbox'
  | 'Workspace'
  | 'OpportunityType'
  | 'Location'
  | 'PrimarySoftware'
  | 'Backup'
  | 'SupplementalSoftware'
  | 'Specialties'
  | 'TypeOfWork'
  | 'ProsRequired'
  | 'MaxConcurrentWorkspaces'
  | 'Status'
  | 'Action'

export type SearchableStaffingSortField =
  | 'WorkspaceId'
  | 'Location'
  | 'PrimarySoftware'
  | 'SupplementalSoftware'
  | 'Status'

export interface StaffingColumnDetails {
  id: ColumnId
  header: string
  align: 'left' | 'center' | 'right'
  select: boolean
  sortable: boolean
  field?: SearchableStaffingSortField
}

export const StaffingTableColumns: StaffingColumnDetails[] = [
  {
    id: 'Checkbox',
    header: '',
    select: false,
    align: 'left',
    sortable: false,
  },
  {
    id: 'Workspace',
    header: 'Workspace',
    select: false,
    align: 'left',
    sortable: false,
  },
  {
    id: 'OpportunityType',
    header: 'Opportunity Type',
    select: false,
    align: 'left',
    sortable: false,
  },
  {
    id: 'Location',
    header: 'Location',
    select: false,
    align: 'left',
    sortable: false,
  },
  {
    id: 'PrimarySoftware',
    header: 'Primary software',
    select: false,
    align: 'left',
    sortable: false,
  },
  {
    id: 'Backup',
    header: 'Backup',
    select: false,
    align: 'center',
    sortable: false,
  },
  {
    id: 'SupplementalSoftware',
    header: 'Supplemental software',
    select: false,
    align: 'left',
    sortable: false,
  },
  {
    id: 'Specialties',
    header: 'Specialties',
    select: false,
    align: 'left',
    sortable: false,
  },
  {
    id: 'TypeOfWork',
    header: 'Type of work',
    select: false,
    align: 'left',
    sortable: false,
  },
  {
    id: 'ProsRequired',
    header: 'Pros required',
    select: false,
    align: 'center',
    sortable: false,
  },
  {
    id: 'MaxConcurrentWorkspaces',
    header: 'Max concurrent workspaces',
    select: false,
    align: 'center',
    sortable: false,
  },
  {
    id: 'Status',
    header: 'Status',
    select: false,
    align: 'center',
    sortable: false,
  },
  {
    id: 'Action',
    header: '',
    select: false,
    align: 'right',
    sortable: false,
  },
]
